import styled from "styled-components";
import { Swiper as OriginalSwiper } from "swiper/react"; // Import the Swiper for styling

export const Wrapper = styled.div`
  width: 100%;
  height: 450px;
`;

export const FirstContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

export const StyledSwiper = styled(OriginalSwiper)`
  width: 100%;
  height: 100%;
  position: relative;

  .textContentWrapper > * {
    opacity: 0;
    transform: translateY(12px);
    transition:
      opacity 0.45s ease,
      transform 0.45s ease;
  }

  .swiper-slide-active .textContentWrapper > * {
    opacity: 1;
    transform: translateY(0);
  }

  .swiper-slide-active .textContentWrapper > *:nth-child(1) {
    transition-delay: 0.08s;
  }

  .swiper-slide-active .textContentWrapper > *:nth-child(2) {
    transition-delay: 0.18s;
  }

  .swiper-slide-active .textContentWrapper > *:nth-child(3) {
    transition-delay: 0.28s;
  }

  @media (max-width: 767px) {
    .swiper-button-next,
    .swiper-button-prev,
    .swiper-pagination-bullets {
      display: none;
    }
  }
`;

export const OverlayContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(105deg, rgba(6, 6, 6, 0.76) 16%, rgba(6, 6, 6, 0.44) 50%, rgba(6, 6, 6, 0.2) 100%);
    z-index: 1;
  }

  .textContentWrapper {
    position: absolute;
    top: 25%;
    left: 20%;
    height: auto;
    display: flex;
    flex-direction: column;
    z-index: 2;

    @media (max-width: 767px) {
      top: 60px;
      left: 30px;
      max-width: 340px;
    }
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%) brightness(0.7) contrast(1.05);
`;

export const OverlayText = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: clamp(2rem, 4.2vw, 2.8rem);
  line-height: 1.12;
  margin: 0;
  z-index: 10000;
  text-shadow: 0 7px 26px rgba(0, 0, 0, 0.5);

  @media (min-width: 768px) {
    max-width: 620px;
  }
`;

export const OverlayTextDescription = styled.p`
  color: ${({ theme }) => theme.colors.body};
  margin: 0.8rem 0 0;
  overflow-wrap: anywhere;
  width: inherit;
  max-width: 430px;
  line-height: 1.65;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.46);
`;

export const SegmentButton = styled.a`
  width: 160px;
  margin-top: 1.1rem;
  font-weight: 700;
  background: ${({ theme }) => theme.colors.primary};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.darkBackground};
  padding: 10px 25px;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 8px;
  text-align: center;

  &:hover {
    color: ${({ theme }) => theme.colors.body};
  }
`;
